
import ZReportList from './document-zreport-list'

export default {
  box: ZReportList,
}
